function showAndHide(e,id){
        e.preventDefault();

        // 切换图标
        // 先关闭全部
        $(".headingContent-arrow").css("background-image", "url('{{'ChevronDownMinor.svg' | asset_url}}')")


        // 再判断展开还是关闭指定id的
        if ($("#hideTextContent"+id).css("display") === "none"){
            $("#hideTextArrow"+id).css("background-image", "url('{{'ChevronUpMinor.svg' | asset_url}}')")
        }else {
            $("#hideTextArrow"+id).css("background-image", "url('{{'ChevronDownMinor.svg' | asset_url}}')")
        }

        // 文本显隐
        $(".hideTextContent").each(function (){
            if ($(this).attr("id") != "hideTextContent"+id){
                $(this).slideUp();
            }
        });

        $("#hideTextContent"+id).slideToggle();

        // 切换图片
        // 先全部隐藏
        $(".hideTextAndPicture-picture").css("display","none");
        // 显示指定id的图片
        $("#hideTextAndPicture-picture-"+id).css("display","block");
    }